export const Styles = {
    tutorialPageTitle: { marginLeft: '25px', marginTop: '25px' },
    tutorialPageContent: { marginLeft: '25px', marginTop: '25px' },
};
